import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Agent } from 'types/agents';

import { AgentSelector } from 'components/AgentSelector';
import { Instructions } from 'components/Instructions/Instructions';

import { useApi } from '../../hooks/useApi';

export const InstructionsPage = () => {
  const { user } = useUser();
  const { apiFetch } = useApi();

  const [agents, setAgents] = useState<Agent[]>([]);

  useEffect(() => {
    if (!user?.id) return;
    
    (async () => {
      try {
        const res = await apiFetch('agents');
        const data: Agent[] = await res.json();

        setAgents(data);
      } catch (e) {
        console.log('Something went wrong', e);
      }
    })();
  }, [user?.id]);

  return (
    <Container maxWidth="xl">
      <Stack spacing={4}>
        {/* Page Header */}
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#2C3E50' }}>
            Instructions
          </Typography>
          <Typography variant="body2" sx={{ color: '#6B7280', mt: 0.5 }}>
            Create and manage agent task schedules
          </Typography>
        </Box>

        {/* Main Content */}
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          spacing={3}
        >
          {/* Add Agent Card */}
          <Card
            sx={{
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0, 153, 204, 0.1)',
              minWidth: { lg: 360 },
              maxWidth: { lg: 400 },
              height: 'fit-content',
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Stack direction="row" alignItems="center" spacing={1.5} mb={3}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '10px',
                    backgroundColor: 'rgba(0, 153, 204, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SmartToyIcon sx={{ color: '#0099CC', fontSize: 22 }} />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#2C3E50' }}>
                  Add New Agent
                </Typography>
              </Stack>
              <AgentSelector
                agents={agents}
                setAgents={setAgents}
              />
            </CardContent>
          </Card>

          {/* Instructions Card */}
          <Card
            sx={{
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0, 153, 204, 0.1)',
              flex: 1,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Instructions agents={agents} />
            </CardContent>
          </Card>
        </Stack>
      </Stack>
    </Container>
  );
};
